import { z4 } from '@fiverr-private/forms';
import { emailValidator } from '../../../../utils/validators';

export const createSchema = () =>
    z4.object({
        email: emailValidator(),
    });

export type FormSchema = z4.infer<ReturnType<typeof createSchema>>;
